// Column definitions for the People/Leads index table.
// Fixed columns (checkbox, name) are always visible and not reorderable.
// Conditional columns (autoPlans, hotScore, showInLeads/finishLead, transactionRole, userType)
// are included but hidden from the dropdown when their feature flag or scope doesn't match.

const allColumns = {
  checkbox: { active: true, position: 1, label: "Checkbox", fixed: true },
  name: { active: true, position: 2, label: "Name", fixed: true },
  showInLeads: { active: true, position: 3, label: "Show in Leads", conditional: "showInLeads" },
  intent: { active: true, position: 4, label: "Intent" },
  status: { active: true, position: 5, label: "Status" },
  stage: { active: true, position: 6, label: "Stage" },
  email: { active: true, position: 7, label: "Email" },
  phone: { active: true, position: 8, label: "Phone" },
  sms: { active: true, position: 9, label: "SMS" },
  appointment: { active: true, position: 10, label: "Appt." },
  mail: { active: true, position: 11, label: "Mail" },
  other: { active: true, position: 12, label: "Other" },
  address: { active: true, position: 13, label: "Address" },
  lastInteraction: { active: true, position: 14, label: "Last Interaction" },
  nextDueTasks: { active: true, position: 15, label: "Next Due Tasks" },
  primaryAgent: { active: true, position: 16, label: "Primary Agent" },
  autoPlans: { active: true, position: 17, label: "Auto Plans", conditional: "autoPlans" },
  birthdate: { active: true, position: 18, label: "Birthdate" },
  homeAnniversary: { active: true, position: 19, label: "Home Anniversary" },
  homeApp: { active: true, position: 20, label: "Home App" },
  hotScore: { active: true, position: 21, label: "Hot Score", conditional: "hotScore" },
  lastVisit: { active: true, position: 22, label: "Last Visit" },
  visits: { active: true, position: 23, label: "Visits" },
  views: { active: true, position: 24, label: "Views" },
  avgViewPrice: { active: true, position: 25, label: "Avg. View Price" },
  favorites: { active: true, position: 26, label: "Favorites" },
  avgFavPrice: { active: true, position: 27, label: "Avg. Fav. Price" },
  listingAlerts: { active: true, position: 28, label: "Listing Alerts" },
  lastSent: { active: true, position: 29, label: "Last Sent" },
  lastOpenedAlerts: { active: true, position: 30, label: "Last Opened (Alerts)" },
  marketReports: { active: true, position: 31, label: "Market Reports" },
  lastOpenedReports: { active: true, position: 32, label: "Last Opened (Reports)" },
  lastViewedReports: { active: true, position: 33, label: "Last Viewed" },
  source: { active: true, position: 34, label: "Source" },
  registered: { active: true, position: 35, label: "Registered" },
  transactionRole: { active: true, position: 36, label: "Transaction Role", conditional: "transactionRole" },
  userType: { active: true, position: 37, label: "User Type", conditional: "userType" },
  tagIcon: { active: true, position: 38, label: "Tag" },
  cmaIcon: { active: true, position: 39, label: "CMA" },
};

export default allColumns;
